import { render, staticRenderFns } from "./CampaignBioPanel.vue?vue&type=template&id=7445d5b8&"
import script from "./CampaignBioPanel.vue?vue&type=script&lang=js&"
export * from "./CampaignBioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports